export const SUPPORT_EMAIL = 'support@smartgridsolutions.com';

/** Pre-filled subject when opening the user's mail client for support. */
export const SUPPORT_TICKET_MAILTO_SUBJECT = 'SGS Portal - Support Request';

export function buildSupportMailtoHref(): string {
  // Use encodeURIComponent (not URLSearchParams) so spaces become %20, not +.
  // Some mail clients show literal "+" in the subject when + is used for spaces.
  const subject = encodeURIComponent(SUPPORT_TICKET_MAILTO_SUBJECT);
  return `mailto:${SUPPORT_EMAIL}?subject=${subject}`;
}
